import { HfsSettingsActionEnum } from 'fleet-data-model';
import { SettingTypeEnum, type Update } from '../../types';

export const mapObstacleAvoidanceEnabledExecutionTarget = (update: Update) => {
  const control = update.group?.find(
    (sub) => sub.settingType === SettingTypeEnum.ObstacleAvoidanceEnabled
  );
  return control === undefined
    ? undefined
    : {
        hfsActionId: HfsSettingsActionEnum.OBSTACLE_AVOIDANCE_ENABLED,
        iprId: update.assetId,
        payload: {
          enabled: control.enabled,
        },
      };
};

export const mapObstacleAvoidanceKeepRunningWithReducedPerformanceExecutionTarget = (
  update: Update
) => {
  const control = update.group?.find(
    (sub) => sub.settingType === SettingTypeEnum.ObstacleAvoidanceKeepRunningWithReducedPerformance
  );
  return control === undefined
    ? undefined
    : {
        hfsActionId:
          HfsSettingsActionEnum.OBSTACLE_AVOIDANCE_VISION_KEEP_RUNNING_WITH_REDUCED_PERFORMANCE,
        iprId: update.assetId,
        payload: {
          keepRunningWithReducedPerformance: control.value === 'CONTINUE',
        },
      };
};

export const mapObstacleAvoidanceProfileExecutionTarget = (update: Update) => {
  const control = update.group?.find(
    (sub) => sub.settingType === SettingTypeEnum.ObstacleAvoidanceProfile
  );
  return control === undefined
    ? undefined
    : {
        hfsActionId: HfsSettingsActionEnum.OBSTACLE_AVOIDANCE_VISION_PROFILE,
        iprId: update.assetId,
        payload: {
          profile: control.value,
        },
      };
};

export const mapObstacleAvoidanceGroupExecutionTargets = (update: Update) => {
  const obstacleAvoidanceEnabled = mapObstacleAvoidanceEnabledExecutionTarget(update);
  const obstacleAvoidanceKeepRunningWithReducedPerformance =
    mapObstacleAvoidanceKeepRunningWithReducedPerformanceExecutionTarget(update);
  const obstacleAvoidanceProfile = mapObstacleAvoidanceProfileExecutionTarget(update);
  if (
    obstacleAvoidanceEnabled === undefined ||
    obstacleAvoidanceKeepRunningWithReducedPerformance === undefined ||
    obstacleAvoidanceProfile === undefined
  ) {
    return [];
  }
  return [
    obstacleAvoidanceEnabled,
    obstacleAvoidanceKeepRunningWithReducedPerformance,
    obstacleAvoidanceProfile,
  ];
};
